import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: 'Sora, -apple-system, Roboto, Helvetica, sans-serif',
  },
});

export default theme;